/* mixed match product js */
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}
      
  $(document).ready(function() {
    var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
    
    $(document).on("click",'fieldset[data-option="choose-bar-or-bag"] label',function() {
     
      var sel_option_data = $(this).find("span").text();
      $('.combo_customizer').attr('data-mixed',sel_option_data);
     
      if( sel_option_data === 'Bar'){
        $('.mixed-bag-wrapper .combo-product-list').each(function(){
          $(this).find('input.quantity-selector__input').val(0);
        });
        $('.combo_customizer .mixed-bag-wrapper.horizontal-product-list').hide();
        $('.combo_customizer .mixed-bar-wrapper.horizontal-product-list').show('slow');
      }
      if( sel_option_data === 'Bag'){
        $('.mixed-bar-wrapper .combo-product-list').each(function(){
          $(this).find('input.quantity-selector__input').val(0);
        });
        $('.combo_customizer .mixed-bar-wrapper.horizontal-product-list').hide();
        $('.combo_customizer .mixed-bag-wrapper.horizontal-product-list').show('slow');
      }

      setTimeout(function(){ 
        var provariantprice = $('.product-info__price sale-price').text();
        var selqty = 1;
        var pricearr = provariantprice.split('.');       
        var pack_price = parseInt($.trim(pricearr[1]));
        var subtotal = pack_price * parseInt(selqty) + '00';
        $('.mix-match-subtotal').html(formatMoney(subtotal, currencyFormat));       
      }, 2000);
      
    });
    
    $(document).on("click",'fieldset[data-option="choose-pack"] label',function() {

      var sel_option_data = $(this).find("span").text();
      $('.combo_customizer').show('slow');
      $('.combo_customizer').attr('data-pack',sel_option_data);
       var input_qty = 0;
        $('.combo-product-list').each(function(){
          var select_qty = $(this).find('input.quantity-selector__input').val();
          input_qty = input_qty + parseInt(select_qty);
        });
      if(input_qty == sel_option_data || input_qty > sel_option_data){
          $('.combo_customizer .quantity-selector__button[aria-label="Increase quantity"]').attr('disabled', true);
        } 
        if(input_qty < sel_option_data){
          $('.combo_customizer .quantity-selector__button').attr('disabled', false);
        }

      setTimeout(function(){ 
        var provariantprice = $('.product-info__price sale-price').text();
        var selqty = 1;
        var pricearr = provariantprice.split('.');       
        var pack_price = parseInt($.trim(pricearr[1]));
        var subtotal = pack_price * parseInt(selqty) + '00';
        $('.mix-match-subtotal').html(formatMoney(subtotal, currencyFormat));       
      }, 2000);
      
    });
    
     $(document).on("click",".special-mix_qty-wrapper .quantity-selector__button",function() {
      var range = parseInt($(this).parents(".combo_customizer").attr("data-pack"));
      var input_qty = 0;
      var provariantprice = parseInt($(this).parents('.horizontal-product__info').attr('data-variant-price'));
        $('.combo-product-list').each(function(){
          var select_qty = $(this).find('input.quantity-selector__input').val();
          input_qty = input_qty + parseInt(select_qty);
        });
        if(input_qty == range || input_qty > range){
          $('.combo_customizer .quantity-selector__button[aria-label="Increase quantity"]').attr('disabled', true);
        } 
        if(input_qty < range){
          $('.combo_customizer .quantity-selector__button').attr('disabled', false);
        }
     });
    
     $(document).on("click",".product-info__quantity-selector:not(.combo_qty) .quantity-selector__button",function() {
	    var provariantprice = $('.product-info__price sale-price').text();
        var selqty = parseInt($(this).parent('quantity-selector').find('input[name="quantity"]').val());
        var pricearr = provariantprice.split('.');       
        var pack_price = parseInt($.trim(pricearr[1]));
        var subtotal = pack_price * parseInt(selqty) + '00';
        $('.mix-match-subtotal').html(formatMoney(subtotal, currencyFormat));
     });
    
    $(document).on("click",".special-mix-controls .buy-buttons button",function(event) {
      event.stopPropagation();
      var selected_pro_index = 0;
      var empty_prod = 0;


      var range = $('.special-mix-controls .option-pack.selected-toggle').data('packqty');
        $('.combo-product-list').each(function(){
          var select_qty = $(this).find('input.quantity-selector__input').val();
          if(select_qty > 0){
            selected_pro_index = parseInt(selected_pro_index) + 1;
            var selected_prod = $(this).find('a span').text();
            console.log('selected_prod : '+ selected_prod + '-' + select_qty);
            var custom_html = '<p class="line-item-property__field hidden"><input id="product-'+selected_pro_index+'" type="text" name="properties[Product-'+selected_pro_index+']" value="'+selected_prod+'-'+select_qty+'"></p>';
            $('.mixed-product-list').append(custom_html);
          }
        });

        $('.special-mix-products .items-cards:not(".hidden")').each(function(){
          var selprotitle = $(this).find('.item-box').data('title'); 
            selected_pro_index = parseInt(selected_pro_index) + 1;
            var custom_html = '<p class="line-item-property__field hidden"><input id="product-'+selected_pro_index+'" type="text" name="properties[Product-'+selected_pro_index+']" value="'+selprotitle+'"></p>';
            $('.mixed-product-list').append(custom_html);
            if($(this).find('.item-box').hasClass("no-product")){
              empty_prod = 1;
            }
        });

        if( empty_prod > 0){
          $(this).parents(".product-info__buy-buttons").find('.error_msg').removeClass('hidden');
          return false;
        }else{
          $(this).parents(".product-info__buy-buttons").find('.error_msg').addClass('hidden');
          return true;
        }
    });
  });


$(document).ready(function() {

$(document).on("click", '.special-mix_qty-wrapper  .quantity-selector__button[aria-label="Increase quantity"]', function() {
        var range = $('.special-mix-controls .option-pack.selected-toggle').data('packqty');
        //var range = parseInt(range_option.replace(/[^0-9]/g,''));
        var input_qty = 0;
        var max_qty = 2;
        var getproduct = $(this).parents(".product-card__info").attr("data-product");
        var getproductimg = $(this).parents(".product-card__info").attr("data-product-image");
        var getproid = $(this).parents(".product-card__info").attr("data-product-id");
        var getprotitle = $(this).parents(".product-card__info").attr("data-product-title");
        var currentobjqty = parseInt($(this).parent('.quantity-selector').find('input').val());
        console.log(currentobjqty + "currentobjqty");
        if(currentobjqty > 2 || currentobjqty == 2){
            $(this).attr('disabled', true);
        } 
        $(".items-cards").each(function() {
            if($(this).find(".item-box").is("[data-product]")){
               input_qty = input_qty + 1;
            }
            if ($(this).find(".item-box").hasClass("no-product")) {
                input_qty = input_qty + 1;
                console.log(getproid);
                $(this).find(".item-box").removeClass("no-product");
                $(this).find(".item-box").attr("data-product", getproid);
                $(this).find(".item-box").attr("data-title", getprotitle);
                var prodata = '<img src="' + getproductimg + '" />';
                $(this).find(".item-box").prepend(prodata);
                return false;
            }
        });
        if(input_qty == range || input_qty > range){
          $('.special-mix_qty-wrapper .quantity-selector__button[aria-label="Increase quantity"]').attr('disabled', true);
        } 
        else if(input_qty < range){
          $('.special-mix_qty-wrapper .quantity-selector__button').attr('disabled', false);
        }
    });
   $(document).on("click", ".icon-btn", function() {
        var minuspro = $(this).parent(".item-box").attr("data-product");
            $(this).parent(".item-box").addClass("no-product"), 
            $(this).parent(".item-box").find("img").remove(), 
            $(this).parent(".item-box").removeAttr("data-product");
            var th = $(".product-card__info[data-product-id=" + minuspro + "]").find('input[name="quantity"]');
            if(th.val() > 0){
              th.val(th.val() - 1);
            }
            $(".quantity-selector__button").attr('disabled', false);
   });
   $(document).on("click", '.quantity-selector__button[aria-label="Decrease quantity"]', function() {
        var getproductid = $(this).parents(".product-card__info").attr("data-product-id");
        $(".item-box[data-product=" + getproductid + "]").each(function(index) {
            $(this).find(".icon-btn").trigger("click");
        });
    });
    $('.variant-picker__option-values .option-pack:first').addClass('selected-toggle');
    $(document).on("click", ".option-pack", function() {
      $('.option-pack').removeClass('selected-toggle');
      $(this).addClass('selected-toggle');
      //var range_option = $(this).text();
      var range = $(this).data('packqty');
     
      //var range = parseInt(range_option.replace(/[^0-9]/g,''));
      var input_qty = 0;
      var max_qty = 2;
        $(".items-cards").each(function(index) {
          if($(this).find(".item-box").is("[data-product]")){
            input_qty = input_qty + 1;
          }
          if(index >= range){
             $(this).find(".icon-btn").trigger("click");
             $(this).addClass('hidden');
          }
          if(index < range){
            $(this).removeClass('hidden');
          }
        });
      
      if(input_qty == range || input_qty > range || input_qty >= max_qty){
        $('.special-mix_qty-wrapper .quantity-selector__button[aria-label="Increase quantity"]').attr('disabled', true);
      } 
      if(input_qty < range){
        $('.special-mix_qty-wrapper .quantity-selector__button').attr('disabled', false);
      }
    });
});

